import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import Loader from "../components/extras/Loader";

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const { status } = useSelector((state: RootState) => state.Auth);

  if (status === "initializing") return <Loader />;

  if (status === "anonymous" || status === "session-expired") {
    return (
      <Navigate
        to="/"
        replace
        state={{ sessionExpired: status === "session-expired", from: location }}
      />
    );
  }

  if (
    status === "verification-required" &&
    location.pathname !== "/app/email-verification"
  ) {
    return <Navigate to="/app/email-verification" replace />;
  }

  return children;
};
